export default {
    type: 'departments',
    aliases: {
        camel: 'departments',
        singular: 'Department',
        plural: 'Departments',
        lowerSingular: 'department',
        lowerPlural: 'departments',
    },
    relations: {},
    publishable: true,
    adminSection: 'about',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerDepartmentRecord',
            loader: () => import('./AdministerDepartmentRecord')
        },
        webRecord: {
            name: 'DisplayDepartmentRecord',
            loader: () => import('./DisplayDepartmentRecord')
        },
    },
};
